import React from 'react';
import { LinkRef, Link as TendUILink } from '@10d/tend-ui/typography/Link';
import { ILinkProps } from './types';

const Component = (
  { testId, ...props }: ILinkProps,
  ref: React.ForwardedRef<LinkRef>,
) => {
  return <TendUILink data-testid={testId} {...props} ref={ref} />;
};

const Link = React.forwardRef(Component) as (
  props: ILinkProps & { ref?: React.ForwardedRef<LinkRef> },
) => ReturnType<typeof Component>;

export default Link;
